<template>
  <div class="layer" v-if="selected">
     <b-container>
       <div class="table-wrapper">
      <div class="centered">
        <div class="inside-wrapper">
        <div class="controls">
          <b-form-select style="max-width: 12em;" v-model="cur" :options="categories"></b-form-select>
          <b-form-radio-group
            id="pricing-grid-corners"
            v-model="corners"
            buttons
            :options="['Square', 'Rounded']"
          />
        </div>
        <PricingTable :category="cur" :corners="corners" />
      </div>
       </div>
       </div>
     </b-container>
    </div>
</template>


<style lang="scss" scoped>
@import "~scss/colors";
.layer {
  background-color: #fff;
  text-align: center;
  // Extra small devices (portrait phones, less than 576px)
  @media (max-width: 575.98px) {
    padding: 0;
  }
}
.container{
 @media (max-width: 992px) {
    margin:0;
    padding:0;
  }
}

.table-wrapper {
  // max-width: 1100px;
  padding: 1em;
  margin: 0 auto 1em auto;
  @media (max-width: 992px) {
    margin: 0 0 1em 0;
    padding: 0;
  }
  @media (max-width: 576px) {
    margin: 0;
    padding: 0;
  }
}

.centered {
  display: inline-block;
}

.inside-wrapper {
  padding: 0 2em 0 1em;
  margin: 0 auto;
    @media (max-width: 1140px) {
    padding:  0 0 0 1em;
  }
   @media (max-width: 992px) {
    padding:0;
  }
}
.controls {
  display: flex;
  justify-content: space-between;
  margin: 0 0 1em 0;
  @media (max-width: 992px) {
    padding: 0;
  }
}

</style>
<style lang="scss">
@import "~scss/colors";
// Buttons are used to provide the radio group
// Override the application level button look (square with caps)
#pricing-grid-corners {
  border: 1px solid #d6d6d6;

  label.btn {
    box-shadow: none !important;
    font-weight: normal;
    text-transform: uppercase;
    border-radius: 0;
    font-size: 14px;
    line-height: 2.5em;
    padding: 0 1em;
    height: auto;
    letter-spacing: 0.5px;
    outline: none !important;
    background-color: #f8f8f8;
    color: #ccc;
    border: none;
    cursor: pointer;
    &.active {
      background-color: white;
      color: black;
    }
  }
}
@media (max-width: 768px) {
  #pricing-grid-corners {
    height: 28px;
    label.btn {
      font-size: 11px;
    }
  }
  .controls > select.form-control {
    font-size: 14px;
    height: 30px;
  }
}

.copy-container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 1em;
  @media (max-width: 992px) {
    padding: 0 .5rem;
  }
}

</style>

<script>
import productData from "@/data/productData.json";
import PricingTable from "./PricingTable";
export default {
  props: ["selected"],
  components: {
    PricingTable
  },
  data() {
    return {
      cur: this.selected,
      corners: "Square"
    };
  },
  computed: {
    categories() {
      return productData.categories.map(c => c.title);
    }
  },
  watch: {
    selected() {
      this.cur = this.selected;
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/pages/homepage/pricing/PricingGrid.vue